export const filterSavedSettings = (savedSettings, searchQuery) => {
    return savedSettings.filter((setting) => {
        if (!searchQuery.trim())
            return true;
        const query = searchQuery.toLowerCase();
        if (setting.name.toLowerCase().includes(query))
            return true;
        const contextParts = [];
        if (setting.settings.accountObjects && setting.settings.accountObjects.length > 0) {
            const accountNames = setting.settings.accountObjects.map((acc) => acc.AccountName);
            contextParts.push(...accountNames);
        }
        if (setting.settings.userObjects && setting.settings.userObjects.length > 0) {
            const userNames = setting.settings.userObjects.map((user) => user.DisplayName);
            contextParts.push(...userNames);
        }
        return contextParts.some((part) => part.toLowerCase().includes(query));
    });
};
//# sourceMappingURL=presetsFilterUtils.js.map